var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.5H7.33333C6.59695 6.5 6 7.09695 6 7.83333V13.8333C6 14.5697 6.59695 15.1667 7.33333 15.1667H13.3333C14.0697 15.1667 14.6667 14.5697 14.6667 13.8333V7.83333C14.6667 7.09695 14.0697 6.5 13.3333 6.5Z",
    stroke: "#386BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 10.5007H2.66634C2.31272 10.5007 1.97358 10.3602 1.72353 10.1101C1.47348 9.86008 1.33301 9.52094 1.33301 9.16732V3.16732C1.33301 2.8137 1.47348 2.47456 1.72353 2.22451C1.97358 1.97446 2.31272 1.83398 2.66634 1.83398H8.66634C9.01996 1.83398 9.3591 1.97446 9.60915 2.22451C9.8592 2.47456 9.99967 2.8137 9.99967 3.16732V3.83398",
    stroke: "#386BFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyHover);
export default __webpack_public_path__ + "static/media/copy-hover.0781ad0283e2bbd3b1e297ebcb75a89a.svg";
export { ForwardRef as ReactComponent };